module.exports = __webpack_public_path__ + "img/ico-whatsapp.989d6d6f.svg";